<script setup lang="ts">
import type {TagItem} from '~/types/legacy'
import type {Populated} from '~/types/populated'

const props = defineProps<{
  tags: Populated<TagItem>[]
}>()
</script>

<template>
  <div class="flex flex-wrap gap-1 pb-1">
    <span
      v-for="tag in props.tags"
      :key="tag ?? undefined"
      class="font-semibold flex-shrink-0 whitespace-nowrap rounded-lg border bg-gray-100 px-3 py-1 text-xs lg:text-sm"
    >
      {{ `# ${tag}` }}
    </span>
  </div>
</template>
